import styled from 'styled-components';

import colors from '~/styles/colors';
import grid from '~/styles/grid';

export const TitlePage = styled.div`
  margin-top: ${grid.xl};
  margin-bottom: ${grid.xl};

  h1 {
    font-weight: bold;
    font-size: 171%;
    color: ${colors.black};
  }
`;
